import './SmallCard.css';
import { useState, useEffect } from 'react';

const SmallCard = (props) => {
    const { subsection, cardSize, cardID, nameID, imgUrl, activeCards, selectCards } = props;
    // console.log('PROOOPS',props)

    const [ isActive, setIsActive ] = useState(false);

    useEffect(() => {
        // console.log('ACTIVE CARDS:', activeCards)
        // console.log('CARD NAME:',cardID)
        if (activeCards.length > 0) {
            if (activeCards.includes(cardID)) {
                setIsActive(true);
            } else {
                setIsActive(false);
            }
        }
    }, [activeCards]);

    const handleClick = (cardID) => {
        // setIsActive(!isActive);
        
        selectCards(cardID, subsection);
    };
    
    return (
        <figure 
            className={isActive ? `card-xs ${cardSize} active` : `card-xs ${cardSize}`}
            onClick={() => handleClick(cardID)}
        >
            <img className='fig-image' src={imgUrl} alt={nameID} />
            <figcaption className='fig-caption'>
                {nameID}
            </figcaption>
        </figure>
    )
};

export default SmallCard;